// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionImageClass{
    width: auto;
    margin: 20px 10px;
    max-width: 818px;
}
.answerImageQuestionInput{
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 8px 8px 0px 0px;
    margin-bottom: 15px;
    height: 50px;
    background: aliceblue;
}
.answerImageQuestionInput:focus{
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Assessment/ImageAssessment/ImageAssessment.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,2BAA2B;AAC/B","sourcesContent":[".questionImageClass{\r\n    width: auto;\r\n    margin: 20px 10px;\r\n    max-width: 818px;\r\n}\r\n.answerImageQuestionInput{\r\n    border: none;\r\n    border-bottom: 1px solid #000;\r\n    border-radius: 8px 8px 0px 0px;\r\n    margin-bottom: 15px;\r\n    height: 50px;\r\n    background: aliceblue;\r\n}\r\n.answerImageQuestionInput:focus{\r\n    box-shadow: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
